// AI Act Classifier motif: a large central AI sparkle-star with smaller stars
// orbiting at varied radii and speeds. Distinct from the Rep node-graph and the
// Policy radar. Two states: calm "holding" and energised "Active Research".
const AQUA = "#2FE1EC";
const TEAL = "#2AA9B5";
const PINK = "#F0508A";
const AMBER = "#E0A100";
const ASPHALT = "#364F6B";
const C = 180;

// concave 4-point AI sparkle path, pinched toward its own centre
const sparkle = (x, y, r) =>
  `M ${x} ${y - r} Q ${x} ${y} ${x + r} ${y} Q ${x} ${y} ${x} ${y + r} Q ${x} ${y} ${x - r} ${y} Q ${x} ${y} ${x} ${y - r} Z`;

// orbiting stars: varied radius, size, colour, speed, phase and direction
const STARS = [
  { r: 60, size: 7, color: AQUA, dur: 17, delay: -2, rev: false },
  { r: 78, size: 5, color: PINK, dur: 23, delay: -9, rev: true },
  { r: 95, size: 10, color: TEAL, dur: 20, delay: -4, rev: false },
  { r: 112, size: 5, color: AMBER, dur: 27, delay: -13, rev: true },
  { r: 130, size: 8, color: AQUA, dur: 31, delay: -7, rev: false },
  { r: 145, size: 4, color: PINK, dur: 25, delay: -18, rev: true },
  { r: 88, size: 4, color: ASPHALT, dur: 21, delay: -11, rev: true },
];

export const AiCore = ({ className = "", active = false }) => {
  return (
    <div
      className={`relative ${active ? "ai-active" : ""} ${className}`}
      data-testid="ai-core-animation"
      aria-hidden="true"
    >
      <div className="ng-glow absolute left-[20%] top-[22%] h-[30%] w-[30%] rounded-full" style={{ background: AQUA, opacity: active ? 0.42 : 0.3 }} />
      <div className="ng-glow absolute right-[18%] bottom-[18%] h-[34%] w-[34%] rounded-full" style={{ background: PINK, opacity: active ? 0.36 : 0.24 }} />

      <svg viewBox="0 0 360 360" className="relative w-full">
        {/* faint depth rings */}
        <circle cx={C} cy={C} r="70" fill="none" stroke={ASPHALT} strokeOpacity="0.07" strokeWidth="1" />
        <circle cx={C} cy={C} r="120" fill="none" stroke={ASPHALT} strokeOpacity="0.06" strokeWidth="1" />

        {/* active-only: scanning pulse from the centre */}
        {active && <circle className="ai-scan" cx={C} cy={C} r="46" fill="none" stroke={AQUA} strokeWidth="2" />}

        {/* orbiting sparkle stars */}
        {STARS.map((s, i) => (
          <g
            key={i}
            className="ai-orbit"
            style={{
              animationDuration: `${active ? (s.dur * 0.5).toFixed(1) : s.dur}s`,
              animationDelay: `${s.delay}s`,
              animationDirection: s.rev ? "reverse" : "normal",
            }}
          >
            <path
              className="ai-twinkle"
              style={{ animationDelay: `${s.delay / 2}s` }}
              d={sparkle(C + s.r, C, s.size)}
              fill={s.color}
            />
          </g>
        ))}

        {/* central AI sparkle-star */}
        <g className="ai-spark">
          <path d={sparkle(C, C, 34)} fill={ASPHALT} />
          <path className="ai-spark-sm" d={sparkle(C + 36, C - 34, 13)} fill={AQUA} />
        </g>
      </svg>
    </div>
  );
};
